import Http from "../../../../../../core/http-axios-react/http/Http";
import { HttpBaseResponse } from "../../../../../../core/HttpResponse";
import { M_InvoicePurchaseConstant } from "../../../../type/Invoice.type";

export const getPurchaseInvoiceConstants = async () => {
  const results = await Http.get<HttpBaseResponse<M_InvoicePurchaseConstant>>({
    url: "/invoice/purchase/constant",
  });
  return results;
};
